import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode ko hata diya hai taake double render na ho
root.render(
    <App />
);

reportWebVitals();